import styled from 'styled-components';
import { Typography } from '@mui/material';

export const Heading = styled(Typography)`
  font-family: Mukta !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  line-height: 24px;
`;

export const Value = styled(Typography)`
  font-family: Mukta !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 24px;
  letter-spacing: 0.02em;
  word-break: break-word;
`;
